'use strict';

import * as util from '../util/Common.js';
import * as domUtil from '../util/Dom.js';

const privateMap = util.createPrivateMapper();


function setTargetLang(target, lang) {
  let langValue = target.valueMap[lang];
  domUtil.empty(target);
  if (!langValue) {
    langValue = target.valueMap['@none'];
  }
  if (!langValue) {
    langValue = target.defaultValue;
  }
  if (!langValue) {
    return;
  }
  target.container.appendChild(langValue);
  // target.setLanguageValue(langValue);
}

export class LanguageControl {
  constructor(langs){
    const pv = privateMap(this);
    pv.targets = [];
    pv.languageMap = {};
    pv.languages = []
    pv.currentLanguage = null;
  }

  initialize(langs){
    pv.languageMap = {};
    pv.languages = []
    if (langs) {
      const l = langs.length;
      for (let i = 0; i < l; i++) {
        pv.languageMap[langs[i]] = true;
        pv.languages[i] = langs[i];
      }
    }
    pv.currentLanguage = null;
    if (pv.languages.length) {
      pv.currentLanguage = languages[0];
    }
  }

  get languages(){
    privateMap(this).languages;
  };
  addTarget(t){
    const pv = privateMap(this);
    util.each(t, (v) => {
      pv.targets.push(v);
      setTargetLang(v, pv.currentLanguage);
    });
  };
  changeLanguage(lang){
    const pv = privateMap(this);
    if (!pv.languageMap[lang]) {
      return;
    }
    pv.currentLanguage = pv.lang;
    util.each(pv.targets, (v) => {
      setTargetLang(v, pv.currentLanguage);
    });
  }
};
